<template>
  <div
    class="border border-gray-200 dark:border-gray-700 rounded-lg p-3 transition-colors"
    :class="isSelected ? 'border-indigo-500 bg-indigo-50 dark:bg-indigo-900/20' : 'hover:bg-gray-50 dark:hover:bg-gray-800'"
  >
    <div class="flex justify-between items-start">
      <div class="flex-1">
        <div class="flex items-center space-x-2 mb-1">
          <span
            v-if="address.is_default"
            class="text-xs px-2 py-1 rounded-full bg-indigo-100 dark:bg-indigo-900/30 text-indigo-800 dark:text-indigo-200"
          >
            Predeterminada
          </span>
        </div>
        
        <p class="text-xs font-medium text-gray-900 dark:text-gray-100">
          {{ address.address }}{{ address.apartment ? `, ${address.apartment}` : '' }}
        </p>
        <p class="text-xs text-gray-600 dark:text-gray-400 mt-1">
          {{ address.neighborhood }}{{ address.city ? `, ${address.city}` : '' }}{{ address.postal_code ? `, ${address.postal_code}` : '' }}
        </p>
        <p
          v-if="address.reference_point"
          class="text-xs text-gray-500 dark:text-gray-400 mt-1"
        >
          Referencia: {{ address.reference_point }}
        </p>
      </div>
      
      <div class="ml-4">
        <DropdownMenu 
          :id="`address-menu-${address.id}`"
          button-label="Actions" 
          width="sm"
        >
          <DropdownMenuItem
            v-if="!address.is_default"
            :icon="StarIcon"
            variant="primary"
            @click="$emit('set-default', address.id)"
          >
            Predeterminar
          </DropdownMenuItem>
          
          <DropdownMenuItem
            :icon="PencilIcon"
            variant="default"
            @click="$emit('edit', address)"
          >
            Editar
          </DropdownMenuItem>
          
          <DropdownMenuDivider />
          
          <DropdownMenuItem
            v-if="showDeleteOption"
            :icon="TrashIcon"
            variant="danger"
            @click="$emit('delete', address.id)"
          >
            Eliminar
          </DropdownMenuItem>
        </DropdownMenu>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { StarIcon, PencilIcon, TrashIcon } from '@heroicons/vue/24/outline';
import DropdownMenu from '@/components/ui/DropdownMenu.vue';
import DropdownMenuItem from '@/components/ui/DropdownMenuItem.vue';
import DropdownMenuDivider from '@/components/ui/DropdownMenuDivider.vue';
import type { CustomerAddress } from '@/types/customer';

interface Props {
  address: CustomerAddress;
  isSelected?: boolean;
  totalAddresses?: number;
}

interface Emits {
  (e: 'set-default', addressId: number): void;
  (e: 'edit', address: CustomerAddress): void;
  (e: 'delete', addressId: number): void;
  (e: 'select', address: CustomerAddress): void;
}

const props = withDefaults(defineProps<Props>(), {
  isSelected: false,
  totalAddresses: 1,
});

const emit = defineEmits<Emits>();

const showDeleteOption = props.totalAddresses > 1;
</script>
